<template>
  <div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div>
          <div class="title">{{ item.tag }}
            <!-- 时间筛选 -->
            <div class="time">
              <el-select v-model="item.time" placeholder="请选择" size="mini" style="width: 160px;"
                @change="changeSelect($event, index)">
                <el-option v-for="item in timeOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- 图表 -->
          <div class="echarts" v-if="item.show">
            <echarts :option="item.option" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { option, pieOption, lineOption } from '@/utlis/echartsOption'
export default {
  props: {
    list: { type: Array },
  },
  data() {
    return {
      val: 'week',
      option: option,
      timeOptions: [
        { value: 'week', label: '周' },
        { value: 'month', label: '月' },
        { value: 'year', label: '年' },
      ],
      translate: {},
      show: true,
      pieOption,
      lineOption,
    };
  },
  created() {

  },
  mounted() {
    this.setEcharts()
  },
  methods: {
    setEcharts() {
      this.list.forEach((item, index) => {
        // 柱状图
        if (item.type != 'line') {
          item.option = JSON.parse(JSON.stringify(this.option)) // 复制模板
          let series = [] //单个图标全部数据
          let data = [] // 图标单条柱子数据
          item[item.time].forEach((items, i) => {
            item.option.legend.data = items.dataDesc//头部标识
            item.option.xAxis.data.push(`${items.start}\n${items.end}`) // 底部数据
            series.push([]) // 加个空的装数据用
            data = [] //重置空的，只要一组
            items.dataValue.forEach((val, valIndex) => {
              series[i].push(val)//拿去每项的数据
              // 添加一项 柱子
              data.push({
                type: "bar", //形状为柱状图
                data: [], //个人订单翻译平均时长,
                name: items.dataDesc[valIndex], // legend属性
                itemStyle: {
                  barBorderRadius: [3, 3, 0, 0]
                },
                barWidth: items.dataValue.length < 5 ? 12 : 8,
                // label: {
                //   // 柱状图上方文本标签，默认展示数值信息
                //   show: true,
                //   position: "top"
                // }
              })
            })
            item.option.color = items.dataValue.length > 5 ? ['#A9DAFB', '#2DA2F2', '#A5F1AC ', '#37E847 ', '#FFD699', '#FEAD33', '#FEC6C6', '#FE7D7D',] : ['#51ACD6', '#6FD882', '#F6C05D', '#FF7364 ',] // 颜色
          })
          let lineData = [] //公司目标
          // 给柱子加数据
          series.forEach((seriesData,) => {
            seriesData.forEach((items, indexs) => {
              data[indexs].data.push(items)
              // 折线图 添加数据
              lineData.push(item.standard)
            })
          })
          // 折线图 标题
          if (item.standard) {
            item.option.legend.data.push(`公司目标-${item.standard}小时`)
          }
          item.option.series = data
          //添加折线图
          item.option.series.push(
            {
              name: `公司目标-${item.standard}小时`,
              type: 'line',
              stack: 'Total',
              // areaStyle: {},
              // emphasis: {
              //   focus: 'series'
              // },
              itemStyle: {
                color: '#6FD882',
              },
              data: lineData
            }
          )
          item.show = true // 重新加载出来
        } else {
          item.option = JSON.parse(JSON.stringify(this.lineOption)) // 复制模板
          item[item.time].forEach((items, i) => {
            item.option.xAxis.data.push(`${items.start}\n${items.end}`) // 底部数据
            item.option.xAxis.type = 'category'
            item.option.yAxis.tooltip = {
              trigger: 'axis'
            }
            let nameList = []
            let seriesData = []
            items.listMap.forEach(map => {
              nameList.push(map.realname)
            })
            nameList.forEach(items => {
              seriesData.push(
                {
                  name: items,
                  type: 'line',
                  // stack: 'Total',
                  showSymbol: false,
                  data: []
                }
              )
            })
            item.option.legend.data = nameList
            item.option.series = seriesData
          })
          item[item.time].forEach((items, i) => {
            items.listMap.forEach(map => {
              item.option.series.forEach(series => {
                if (map.realname == series.name) {
                  series.data.push((map.avg / 3600).toFixed(2))
                }
              })

            })
          })
          item.show = true // 重新加载出来
        }

        this.$forceUpdate()
      })
    },
    //切换日期格式
    changeSelect(e, i) {
      // 隐藏重新加载图标
      this.list[i].show = false
      this.$nextTick(() => {
        this.setEcharts()
      }, 1000);
    },
  }
}
</script>

<style lang='scss' scoped>
.list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .item {
    width: 47.5%;
    background-color: #fff;
    padding: 1%;
    border-radius: 8px;
    margin-bottom: 24px;

    .echarts {
      width: 96%;
    }

    &:nth-child(odd) {
      margin-right: 1%;
    }

    .title {
      display: flex;
      justify-content: space-between;
    }

  }
}
</style>